import { FullSportFragment } from "../../../types";

type Gender = "Men's" | "Women's";

export interface TeamFormState {
  id: string;
  sport: FullSportFragment | null;
  gender: Gender | null;
  name: string | null;
}

interface ChangeGender {
  type: "CHANGE_GENDER";
  payload: Gender | null;
}

interface ChangeSport {
  type: "CHANGE_SPORT";
  payload: FullSportFragment;
}

interface ChangeName {
  type: "CHANGE_NAME";
  payload: string;
}

export type TeamFormAction = ChangeGender | ChangeSport | ChangeName;

export const teamFormReducer = (state: TeamFormState, action: TeamFormAction): TeamFormState => {
  switch (action.type) {
    case "CHANGE_GENDER":
      return {
        ...state,
        gender: action.payload,
        name: state.name ? state.name : `${action.payload + (state.sport ? state.sport.name : "")}`,
      };
    case "CHANGE_SPORT":
      return {
        ...state,
        sport: action.payload,
        name:
          state.gender && state.name && state.name !== state.gender
            ? state.name
            : `${state.gender ? state.gender : ""} ${action.payload.name}`,
      };
    case "CHANGE_NAME":
      return { ...state, name: action.payload };
  }
};

export const teamFormToSaveTooltips = (state: TeamFormState): string[] => {
  let tooltips = [];

  if (state.name === null) {
    tooltips.push("'Name' is required!");
  }
  return tooltips;
};
